import { render, staticRenderFns } from "./TaxCalculator.vue?vue&type=template&id=ac3bd7ce"
import script from "./TaxCalculator.vue?vue&type=script&lang=js"
export * from "./TaxCalculator.vue?vue&type=script&lang=js"
import style0 from "./TaxCalculator.vue?vue&type=style&index=0&id=ac3bd7ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports